import styles from './add.modal.module.scss'

import { state } from '../store/state'
import elements from '../store/elements'
import setSizeToImgSrc from '../helpers/setSizeToImgSrc'
import { isNotNullOrUndef } from '../../../utils/isNotNullOrUndef'

const doc = document
const win = window
const vn = win.vNode
const overlay = doc.querySelector('.main-overlay')
let modalVNode = null

const variantImage = () => {
  return state.variant.featured_image && state.variant.featured_image.src
    ? setSizeToImgSrc(state.variant.featured_image.src, 200)
    : elements.image.src
}

const createModalVNode = (quantity, itemData) => {
  const sku = itemData.sku
  const { price: pNew } = state.variant
  const oldPrice = (pNew / 100).toFixed(2)
  const newPrice = (pNew * 0.85 / 100).toFixed(2)

  return vn.create(
    'div',
    {
      class: `${styles.modal} responsive-fz-m responsive-fz-d--md-up pos:f m:auto`,
      'data-cy-test': 'AddToCartModal'
    },
    [
      vn.create(
        'button',
        {
          class: `${styles.close} btn:cleared pos:a`,
          'data-cy-test': 'AddToCartModal-close',
          events: {
            click: close
          }
        },
        [vn.create('s-svg', { class: 'h:100p w:100p', 'data-icon': '#icon--close-x' })]
      ),
      // BODY
      vn.create(
        'div',
        { class: styles.body },
        [
          vn.create(
            'p',
            {
              class: `${styles.title} d:flex ai:center fw:700`
            },
            [
              vn.create('s-svg', { 'data-icon': '#icon--check-mark' }),
              'ITEM SUCCESSFULLY ADDED TO CART'
            ]
          ),
          // Product
          vn.create(
            'div',
            { class: `${styles.row} d:flex` },
            [
              vn.create(
                'img',
                {
                  class: styles.productImage,
                  'data-cy-test': 'AddToCartModal-image',
                  src: variantImage(),
                  height: 200,
                  width: 200,
                  alt: '',
                  style: 'background-color: #f2f3f4'
                }
              ),
              vn.create(
                'div',
                {
                  class: `${styles.productContent} fx:1 d:flex fd:column jc:between`
                },
                [
                  vn.create(
                    'p',
                    { class: `${styles.productTitle} fw:700` },
                    [window.productPage.title]
                  ),
                  vn.create(
                    'div',
                    { class: `${styles.productData} lts:002` },
                    [
                      // options
                      ...itemData.options_with_values.reduce((arr, { name, value }) => {
                        if (itemData.sku === 'Custom_FR2' && name === 'Color') {
                          return arr
                        }
                        arr.push(
                          vn.create('div', [
                            vn.create('span', [`${name.toUpperCase()}: `]),
                            vn.create('span', [value])
                          ])
                        )
                        return arr
                      }, []),
                      // props
                      ...(
                        isNotNullOrUndef(itemData.properties)
                          ? Object.keys(itemData.properties).sort().reduce((arr, propKey) => {
                            if (!propKey.startsWith('_')) {
                              arr.push(vn.create('div', [
                                vn.create('span', [`${propKey.toUpperCase()}: `]),
                                vn.create('span', [itemData.properties[propKey]])
                              ]))
                            }
                            return arr
                          }, [])
                          : []
                      )
                    ]
                  )
                ]
              ),
              vn.create(
                'div',
                { class: 'text:right' },
                [
                  vn.create('s', { class: styles.productPriceOld }, [`$${oldPrice}`]),
                  vn.create('span', { class: `${styles.productPriceNew} d:block fw:700` }, [`$${newPrice}`])
                ]
              )
            ]
          ),
          // Buttons
          vn.create(
            'div',
            {
              class: `${styles.row} ${styles.buttons} d:flex jc:end`,
              'data-cy-test': 'AddToCartModal-buttons'
            },
            [
              vn.create(
                'a',
                {
                  href: '/cart',
                  class: `${styles.button} ${styles.buttonCart} d:flex ai:center jc:center fw:700 lts:002`
                },
                ['VIEW CART']
              ),
              vn.create(
                'form',
                {
                  action: '/cart',
                  method: 'post',
                  class: styles.formCheckout
                },
                [
                  vn.create(
                    'button',
                    {
                      type: 'submit',
                      name: 'checkout',
                      class: `${styles.button} ${styles.buttonCheckout} btn:cleared d:flex ai:center jc:center w:100p fw:700 lts:002`,
                      'data-dl-event': 'checkoutStart',
                      events: {
                        click: (e) => {
                          e.currentTarget.firstElementChild.hidden = true
                          e.currentTarget.lastElementChild.hidden = false
                        }
                      }
                    },
                    [
                      vn.create('span', ['CHECKOUT']),
                      vn.create('i', { class: `${styles.buttonLoader} icon--loader d:inline-block bdrs:50p`, hidden: true })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      // FOOTER
      vn.create(
        'div',
        { class: `${styles.footer} d:flex` },
        [
          [
            `<svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(1, 1)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path d="M20,19.9155119 L20,16.8214388 C20,13.6116995 22.2438896,11 25.0020125,11 C27.757776,11 30,13.6116995 30,16.8214388 L30,20" stroke="#5E6A74"></path>
                  <path d="M49.9920673,13.5657457 C49.9812665,13.1235064 49.5638496,12.7511349 49.0015757,12.681843 C41.9645747,11.8154074 40.9137261,6.67264892 40.9137261,3.68446308 C40.9137261,3.26295383 40.542477,2.89653253 40.0155703,2.79729743 L35.9502557,2.032976 L33.6012003,1.59112067 L25.2763696,0.0256245381 C25.094663,-0.00854151271 24.9055441,-0.00854151271 24.7238375,0.0256245381 L9.98463691,2.79729743 C9.45773013,2.89653253 9.0864811,3.26295383 9.0864811,3.68446308 C9.0864811,6.67264892 8.03584423,11.8154074 0.998419673,12.681843 C0.436145758,12.7511349 0.0189406306,13.1235064 0.00792810946,13.5657457 C-0.0439578074,15.662735 0.0576962338,23.1168844 3.54527696,30.988896 C4.10479775,32.2518883 4.72276961,33.4597925 5.39474518,34.6156799 L6.53094086,36.4410684 C10.7303117,42.7383706 16.7598788,47.2621093 24.5262475,49.9226465 C24.6772461,49.9740875 24.8388337,50 25,50 C25.1613735,50 25.3229611,49.9740875 25.4739597,49.9226465 C35.3250834,46.5480772 42.3841094,40.1778362 46.4549302,30.988896 C49.9425109,23.1168844 50.0439532,15.662735 49.9920673,13.5657457 Z" stroke="#5E6A74"></path>
                  <path d="M25,25 C23.8972564,25 23,25.9430796 23,27.1020801 C23,27.7847068 23.3152296,28.4207508 23.8432251,28.8016155 C24.0699888,28.9662663 24.2057671,29.2363872 24.2057671,29.5246725 L24.2057671,31.1688361 C24.2057671,31.6267526 24.5618701,32 25,32 C25.4426092,32 25.8029115,31.6267526 25.8029115,31.1688361 L25.8029115,29.5246725 C25.8029115,29.2407818 25.9344905,28.9738836 26.1559351,28.8083539 C26.6842105,28.4154773 27,27.7770895 27,27.1020801 C27,25.9430796 26.1027436,25 25,25 Z" stroke="#F08D8A"></path>
                  <rect stroke="#5E6A74" x="16" y="20" width="18" height="16" rx="2"></rect>
                </g>
              </svg>`,
            vn.create('span', ['SECURE', vn.create('br'), 'CHECKOUT'])
          ],
          [
            `<svg viewBox="0 0 54 52" xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(1, 1)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M40.7240653,21.6809754 L33.8052,10.6598333 C33.6336,10.3919664 33.3335918,10.2293748 33.0125714,10.2293748 L7.92978776,10.2293748 C7.60643265,10.2293748 7.30759184,10.3919664 7.13832653,10.6574939 L0.140081633,21.6786359 C0.0910530612,21.754668 0.119069388,21.8447368 0.100391837,21.9277872 C0.0735428571,22.0061587 -2.09140881e-14,22.0623055 -2.09140881e-14,22.153544 L-2.09140881e-14,49.0958031 C-2.09140881e-14,49.5964451 0.41557551,50 0.93037551,50 L39.9314367,50 C40.443902,50 40.8571429,49.5964451 40.8571429,49.0958031 L40.8571429,22.153544 C40.8571429,22.0623055 40.7847673,22.0061587 40.7590857,21.9254478 C40.7404082,21.8447368 40.7719265,21.7570075 40.7240653,21.6809754" stroke="#5E6A74"></path>
                <line x1="40.8571429" y1="22.7155013" x2="-2.09140881e-14" y2="22.7155013" stroke="#5E6A74"></line>
                <line x1="23.2142857" y1="10.4883463" x2="24.1428571" y2="22.2530522" stroke="#5E6A74"></line>
                <line x1="15.7857143" y1="10.4883463" x2="14.8571429" y2="22.2530522" stroke="#5E6A74"></line>
                <path d="M24.1428571,22.2530522 L24.1428571,28.7690799 C24.1428571,29.2572926 23.7440841,29.6522383 23.2514822,29.6522383 L15.7485178,29.6522383 C15.2559159,29.6522383 14.8571429,29.2572926 14.8571429,28.7690799 L14.8571429,22.2530522" stroke="#5E6A74"></path>
                <path d="M21.3571429,2.83018868 L39.158871,2.83018868 C47.5146877,2.83018868 51.7593246,10.3695244 51.9908073,17.2831257 C52.1809538,22.8865591 49.4137907,27.6822904 44.3873093,29.6522383" stroke="#F18E8A"></path>
                <line x1="23.2142857" y1="2.76467302e-14" x2="20.4285714" y2="2.77469478" stroke="#F18E8A" stroke-linecap="round" stroke-linejoin="round"></line>
                <line x1="23.2142857" y1="5.54938957" x2="20.4285714" y2="2.77469478" stroke="#F18E8A" stroke-linecap="round" stroke-linejoin="round"></line>
              </g>
            </svg>`,
            vn.create('span', ['90-DAY MONEY BACK', vn.create('br'), 'GUARANTEE'])
          ],
          [
            `<svg viewBox="0 0 49 54" xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(1, 1)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path d="M47.4211167,28.6336957 C47.4232945,32.9782609 42.0899167,35.951087 41.2155389,36.5326087 C41.2155389,40.1380435 38.8787834,40.3413043 38.3463167,40.3413043 L36.0052056,40.3413043 C34.1181612,40.3413043 32.5828278,38.8043478 32.5828278,36.9293478 L32.5828278,22.6402174 C32.5828278,20.7652174 34.1181612,19.2413043 36.0052056,19.2413043 L38.2352501,19.2413043 C40.0493389,19.2413043 41.2100945,19.8586957 41.2100945,23.5565217 L43.5109167,23.5565217 L43.5109167,22.8173913 C43.5109167,12.3804348 34.9457167,3.88695652 23.7083834,3.88695652 C12.4819389,3.88695652 3.91891672,12.3804348 3.91891672,22.8173913 L3.91891672,23.5565217 C4.2248945,23.5402174 6.22082783,23.5565217 6.22082783,23.5565217 C6.22082783,20.1576087 7.75942783,19.2413043 9.19676116,19.2413043 L11.3810723,19.2413043 C13.2681167,19.2413043 14.8045389,20.7652174 14.8045389,22.6402174 L14.8045389,36.9293478 C14.8045389,38.8043478 13.2681167,40.3402174 11.3810723,40.3402174 L9.19676116,40.3402174 C7.70825005,40.3402174 6.22082783,39.4336957 6.22082783,36.5434783 C3.95593894,35.151087 -0.00543883826,32.2195652 5.68434189e-14,28.6336957 C5.68434189e-14,28.5336957 0.00436116174,22.8173913 0.00436116174,22.8173913 C0.00436116174,10.2358696 10.3248501,-2.13162821e-14 23.7083834,-2.13162821e-14 C37.1028056,-2.13162821e-14 47.4254723,10.2358696 47.4254723,22.8173913 C47.4254723,22.8173913 47.4211167,28.598913 47.4211167,28.6336957 Z" stroke="#5E6A74"></path>
                <path d="M27.7003589,46.7998913 C28.5529589,46.7998913 29.2759812,47.4738043 29.2759812,48.2629348 L29.2672701,50.7498913 C29.2650923,51.5531522 28.5442478,52.2292391 27.6916478,52.231413 C27.6916478,52.231413 22.6653367,52.2216304 21.7789812,52.2216304 C20.8915367,52.2216304 20.1990034,51.5346739 20.1990034,50.7520652 C20.1990034,49.9672826 20.2022701,48.2466304 20.2022701,48.2466304 C20.2022701,47.4411957 20.9035145,46.7857609 21.7724478,46.7857609 L27.7003589,46.7998913 Z" stroke="#F18E8A"></path>
                <path d="M29.1099256,49.2561957 C38.3905256,48.5692391 40.7860812,44.7681522 41.6571923,41.5801087 C41.6550145,41.5822826 41.6550145,41.5855435 41.6517478,41.5877174" stroke="#F18E8A"></path>
              </g>
            </svg>`,
            vn.create('span', ['24/7', vn.create('br'), 'SUPPORT'])
          ],
          [
            `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.238 50.5">
              <g transform="translate(0.5 0.5)">
                <g transform="translate(0 0)">
                  <path d="M562.362,798.542h8.821a2.72,2.72,0,0,1,2.245,1.182l4.622,8.3h1.359c1.528,0,3.844,1,3.844,2.993v5.673a2.718,2.718,0,0,1-2.715,2.714h-3.053" transform="translate(-526.014 -779.402)" fill="rgba(0,0,0,0)" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path d="M544.44,782.263h13.869V825.49H546.395" transform="translate(-529.217 -782.263)" fill="rgba(0,0,0,0)" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line x1="3.081" transform="translate(0.263 43.227)" fill="none" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <g transform="translate(-527.43 -781.094)" fill="rgba(0,0,0,0)" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M 574.0689086914062 830.5944213867188 C 571.3433837890625 830.5944213867188 569.1260375976562 828.3931884765625 569.1260375976562 825.6875610351562 C 569.1260375976562 822.9820556640625 571.3433837890625 820.7809448242188 574.0689086914062 820.7809448242188 C 576.7953491210938 820.7809448242188 579.0134887695312 822.9820556640625 579.0134887695312 825.6875610351562 C 579.0134887695312 828.3931884765625 576.7953491210938 830.5944213867188 574.0689086914062 830.5944213867188 Z" stroke="none"/>
                    <path d="M 574.0689086914062 821.2809448242188 C 571.6190795898438 821.2809448242188 569.6260375976562 823.2577514648438 569.6260375976562 825.6875610351562 C 569.6260375976562 828.1174926757812 571.6190795898438 830.0944213867188 574.0689086914062 830.0944213867188 C 576.5196533203125 830.0944213867188 578.5134887695312 828.1174926757812 578.5134887695312 825.6875610351562 C 578.5134887695312 823.2577514648438 576.5196533203125 821.2809448242188 574.0689086914062 821.2809448242188 M 574.0689086914062 820.2809448242188 C 577.0768432617188 820.2809448242188 579.5134887695312 822.7015991210938 579.5134887695312 825.6875610351562 C 579.5134887695312 828.6737670898438 577.0768432617188 831.0944213867188 574.0689086914062 831.0944213867188 C 571.0643920898438 831.0944213867188 568.6260375976562 828.6737670898438 568.6260375976562 825.6875610351562 C 568.6260375976562 822.7015991210938 571.0643920898438 820.2809448242188 574.0689086914062 820.2809448242188 Z" stroke="none" fill="#5e6a74"/>
                  </g>
                  <g transform="translate(-530.666 -781.094)" fill="rgba(0,0,0,0)" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M 539.011474609375 830.5944213867188 C 536.2867431640625 830.5944213867188 534.070068359375 828.3931884765625 534.070068359375 825.6875610351562 C 534.070068359375 822.9820556640625 536.2867431640625 820.7809448242188 539.011474609375 820.7809448242188 C 541.7379150390625 820.7809448242188 543.9560546875 822.9820556640625 543.9560546875 825.6875610351562 C 543.9560546875 828.3931884765625 541.7379150390625 830.5944213867188 539.011474609375 830.5944213867188 Z" stroke="none"/>
                    <path d="M 539.011474609375 821.2809448242188 C 536.5625 821.2809448242188 534.570068359375 823.2577514648438 534.570068359375 825.6875610351562 C 534.570068359375 828.1174926757812 536.5625 830.0944213867188 539.011474609375 830.0944213867188 C 541.4622192382812 830.0944213867188 543.4560546875 828.1174926757812 543.4560546875 825.6875610351562 C 543.4560546875 823.2577514648438 541.4622192382812 821.2809448242188 539.011474609375 821.2809448242188 M 539.011474609375 820.2809448242188 C 542.0184326171875 820.2809448242188 544.4560546875 822.7015991210938 544.4560546875 825.6875610351562 C 544.4560546875 828.6737670898438 542.0184326171875 831.0944213867188 539.011474609375 831.0944213867188 C 536.0067138671875 831.0944213867188 533.570068359375 828.6737670898438 533.570068359375 825.6875610351562 C 533.570068359375 822.7015991210938 536.0067138671875 820.2809448242188 539.011474609375 820.2809448242188 Z" stroke="none" fill="#5e6a74"/>
                  </g>
                  <line x2="6.118" transform="translate(31.421 43.227)" fill="none" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path d="M567.372,810.962h7.144V809.6l-2.716-4.062" transform="translate(-529.977 -782.25)" fill="rgba(0,0,0,0)" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line x2="13.701" transform="translate(5.328 24.047)" fill="none" stroke="#f08d8a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line x2="9.973" transform="translate(4.607 14.295)" fill="none" stroke="#f08d8a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line x1="2.717" transform="translate(0 14.295)" fill="none" stroke="#f08d8a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line x1="2.716" transform="translate(4.471 0.362)" fill="none" stroke="#5e6a74" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </g>
              </g>
            </svg>`,
            vn.create('span', ['FREE US', vn.create('br'), 'SHIPPING'])
          ]
        ].map(iconContent => {
          return vn.create(
            'div',
            { class: 'fx:1 d:flex ai:center jc:center fd:column fd:row:lg-up text:center text:left:lg-up fw:700' },
            iconContent
          )
        })
      )
    ]
  )
}

const show = ({ quantity, itemData }) => {
  const newVNode = createModalVNode(quantity, itemData)
  vn.patch(modalVNode, newVNode, doc.body)
  modalVNode = newVNode

  if (overlay) {
    overlay.setAttribute('aria-hidden', 'false')
    overlay.addEventListener('click', close)
  }
}

const close = () => {
  !!modalVNode && vn.unmount(modalVNode)
  modalVNode = null
  det = null

  if (overlay) {
    overlay.setAttribute('aria-hidden', 'true')
    overlay.removeEventListener('click', close)
  }
}

let subscribedToCart = false
let det = null
const subscribeToCart = () => {
  if (subscribedToCart || !win.cart) return

  win.cart.on('total', () => {
    !!det && show(det)
  })

  subscribedToCart = true
}

const addModal = () => {
  doc.addEventListener('addToCart', ({ detail }) => {
    det = detail

    // subscribe to cart changes
    subscribeToCart()
  })

  // subscribe to cart changes
  subscribeToCart()
}

export default addModal
